import { Chip } from "@gigpro/ui/Chip";
import { Star } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";

interface PreferredProChipProps extends React.ComponentProps<typeof Chip> {}

export const PreferredProChip: React.FC<PreferredProChipProps> = ({ className, ...props }) => (
  <Chip className={cn("w-fit bg-accent-light-green font-regular", className)} {...props}>
    <Star className="size-2 text-black" />
    Preferred Pro
  </Chip>
);
